<template>
    <div class="wrapper">
            <dashboard-content>
            </dashboard-content>

            <content-footer></content-footer>
    </div>
</template>
<style lang="scss">

</style>
<script>
    import ContentFooter from './ContentFooter.vue'
    import DashboardContent from './Content.vue'

    export default {
        components: {
            ContentFooter,
            DashboardContent,
        },
        methods: {}
    }

</script>
